import template from './trip-justification.html';

const DIRECTIVE_NAME = TripJustification.DIRECTIVE_NAME = 'ktJustification';
export default function TripJustification() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripJustificationController,
        controllerAs: '$ctrl',
        scope: {
            tripData: `=${DIRECTIVE_NAME}TripData`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripJustificationController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
        isTextVisible,
    });

    function $onInit() {
        vm.isJustificationTextVisible = isTextVisible();
    }

    function isTextVisible() {
        if (vm.tripData.IsJustificationTextRequired) {
            return true;
        }
            return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-justification/trip-justification-component.js